import * as styles from "./Spinner.module.css";

const Spinner = () => <span className={styles.container}>⊛</span>;

export default Spinner;
